// ===========================================================================
// ENTRADA DEL HOME — deliberadamente ligera.
//
// Aquí NO se importa three.js. Todo lo que el visitante ve y toca en los
// primeros segundos —el header, el hero de Julio (que es el elemento del LCP) y
// las secciones— se monta con módulos que suman decenas de KB, no cientos.
//
// El recorrido 3D pesa ~864 KB y vive en `./three/journey.js`. Se trae con
// `import()` cuando el navegador ya terminó de pintar, y no se ve hasta que el
// scroll pasa los HERO_LEAD_PX del hero: para entonces lleva rato cargado.
// Antes se importaba de forma estática y el hero esperaba al motor 3D para
// existir.
// ===========================================================================
import { HERO_LEAD_PX, VH_PER_SCENE, SCENE_COUNT } from './config/rail.js';
import { createScroll } from './scroll/index.js';
import { createHeader } from './overlay/header.js';
import { mountHeroJulio } from './sections/heroj/heroj.js';
import { mountSections } from './sections/index.js';

const scrollEl = document.getElementById('scroll');
const stage = document.getElementById('stage');

// El riel es COMPARTIDO: sus primeros HERO_LEAD_PX los ocupa el hero y de ahí
// en adelante corre el recorrido 3D. Se dimensiona ANTES de montar nada, para
// que la página no cambie de alto después del primer pintado (eso es CLS).
scrollEl.style.height = `calc(${HERO_LEAD_PX}px + ${SCENE_COUNT * VH_PER_SCENE}vh)`;

// Lenis mueve el scroll de TODA la página, así que arranca en el frame uno: si
// esperara al 3D, los primeros scrolls del visitante serían bruscos y el resto
// suaves. Su rAF vive AQUÍ, no en el recorrido.
const scroll = createScroll(scrollEl, HERO_LEAD_PX);
window.__zkLenis = scroll.lenis;   // quien necesite scroll programado lo pausa
(function raf(t) { scroll.raf(t); requestAnimationFrame(raf); })(0);

createHeader(document.querySelector('.zk'));
mountHeroJulio(stage, {
  rail: scrollEl,
  leadPx: HERO_LEAD_PX,
  overlay: document.getElementById('overlay'),
});
mountSections(document.getElementById('sections'));

// --- El recorrido 3D, en diferido -----------------------------------------
// `requestIdleCallback` espera a que el hilo principal esté libre, o sea justo
// después del primer pintado. El `timeout` es la red de seguridad: en una
// máquina ocupada el navegador podría no encontrar nunca un hueco, y el 3D
// tiene que estar listo antes de que el visitante llegue a él.
// `?sin3d` deja el hero y las secciones SIN el recorrido: sirve para medir
// cuánto del costo de scroll es del motor 3D y cuánto del resto de la página.
// Es una herramienta de diagnóstico, igual que `?debug`; nadie llega aquí sin
// escribirlo a mano.
let arrancado = new URLSearchParams(location.search).has('sin3d');
const arrancar = () => {
  if (arrancado) return;
  arrancado = true;
  import('./three/journey.js')
    .then((m) => m.startJourney({ scroll }))
    .catch((e) => console.error('[zenkai] el recorrido 3D no cargó:', e));
};
if ('requestIdleCallback' in window) requestIdleCallback(arrancar, { timeout: 1500 });
else setTimeout(arrancar, 400);
// Si el visitante scrollea antes de que llegue el hueco, no se le hace esperar.
addEventListener('scroll', arrancar, { once: true, passive: true });
